import { CheckCircleIcon } from '@heroicons/react/20/solid';

export interface SuccessAlertProps {
  text: string;
}

export const SuccessAlert = (props: SuccessAlertProps) => {
  return (
    <div className="rounded-md bg-success-subtle p-4">
      <div className="flex">
        <div className="shrink-0">
          <CheckCircleIcon aria-hidden="true" className="size-5 text-success" />
        </div>
        <div className="ml-3 flex-1 md:flex md:justify-between">
          <p className="text-sm text-success">{props.text}</p>
        </div>
      </div>
    </div>
  );
};
